module.exports = __webpack_public_path__ + "static/media/service-backend.75419c98.svg";